import React from 'react';
import PropTypes from 'prop-types';

import { ACTION_HIDDEN_MOD } from './translations';

import styles from './ActionHiddenMod.module.css';

export default class ActionHiddenMod extends React.PureComponent {
    static propTypes = {
        onClick: PropTypes.func,
    }

    render() {
        return (
            <div className={styles.base} onClick={this.props.onClick}>
                {ACTION_HIDDEN_MOD}
            </div>
        )
    }
}
